import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, setPropTypes, lifecycle } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import moment from 'moment';
import CheckOkButton from '../../components/atoms/CheckOkButton';
import CheckNgButton from '../../components/atoms/CheckNgButton';
import ProgressDialog from '../../components/molecules/ProgressDialog';

const styles = {
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none'
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '0px',
    overflowY: 'auto',
    height: '500px'
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  description: {
    color: '#707070',
    margin: '20px 0px 0px'
  },
  subTitle: {
    margin: '20px 0px 0px',
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  divider: {
    margin: '20px 0px'
  },
  detailTable: {
    width: 'auto'
  },
  tableCellItem: {
    border: '2px solid #ffffff',
    backgroundColor: '#e0e0e0'
  },
  tableCellData: {
    border: '2px solid #ffffff',
    whiteSpace: 'pre-wrap'
  },
  textField100: {
    padding: '0px 5px 0px 5px',
    width: '100px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  textFieldLong: {
    padding: '0px 5px 0px 5px',
    width: '400px'
  },
  editTable: {
    width: 'auto'
  },
  tableCell: {
    border: '2px solid #ffffff'
  },
  button: {
    marginTop: 20,
    marginBottom: 20
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    name: state.loginInfo.name,
    taxTypes: state.gochiMenus.taxTypes
  })),
  setPropTypes(propTypes),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    updateOpenDetailModal,
    openDetailProgress,
    progressOkAction,
    loading,
    resultMessage,
    detailUser
  }) => {
    return (
      <div className={classes.root}>
        <Typography variant="h6">
          {`優遇困窮者氏名：${detailUser.displayName}
          （ユーザID：${detailUser.userId})`}
        </Typography>
        <div>
          <Button
            onClick={() => updateOpenDetailModal(false)}
            variant="contained"
            color="primary"
            className={classes.button}
          >
            優遇困窮者一覧に戻る
          </Button>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>こどもごちめし対象者ID</TableCell>
                <TableCell>こども氏名</TableCell>
                <TableCell>生年月</TableCell>
                <TableCell>住所</TableCell>
                <TableCell>生年月日確認状況</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {detailUser.userKids.map(item => {
                return (
                  <TableRow key={item.userKidId}>
                    <TableCell>{item.userKidId}</TableCell>
                    <TableCell>{item.displayName}</TableCell>
                    <TableCell>
                      {moment(item.birthday).format('YYYY/MM')}
                    </TableCell>
                    <TableCell>
                      {`${item.prefectures ? item.prefectures : ''} ${
                        item.city ? item.city : ''
                      }`}
                    </TableCell>
                    <TableCell>
                      {item.status && item.status === 'OK' ? (
                        <CheckOkButton />
                      ) : (
                        <CheckNgButton />
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Paper>
        <ProgressDialog
          openProgress={openDetailProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
